<template>
  <div>
    <div v-if="fuse">
      <h4>Details for {{fuse.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{fuse[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="fuse.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "fuse",
  components: {
    BFR
  },
  props: {
    fuse: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["ampRating", "Amp Rating"],
      ["voltageRating", "Voltage Rating"],
      ["classDesignation", "Class Designation"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
